import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { NoticeForm } from "pages/notice/NoticeForm";
import { fetchNotice, updateNotice } from "shared/api/NoticeApi";
import { alertDialog } from "shared/ui/feedback";

const EditNoticePage = () => {
  const noticeId = useParams().noticeId;
  const [loaded, setLoaded] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const data = await fetchNotice(() => {}, noticeId);
        if (!cancelled) setLoaded(data);
      } catch (error) {
        alertDialog(
          "공지사항을 불러오는 중 에러가 발생했습니다. 에러 사유: " + error,
          { title: "공지사항 불러오기 실패" },
        );
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [noticeId]);

  const initialValues = loaded
    ? {
        title: loaded.title,
        pin: loaded.pin,
        files: loaded.files,
        image: loaded.image,
        content: loaded.content,
        engTitle: loaded.engTitle ?? "",
        engContent: loaded.engContent ?? "",
      }
    : null;

  return (
    <NoticeForm
      mode="edit"
      initialValues={initialValues}
      onSubmit={(data) => updateNotice(noticeId, data)}
    />
  );
};

export default EditNoticePage;
